import { useState, useEffect } from "react";
import AutoTicketRules from "./AutoTicketRules";
import {
  useTeamMutation,
  useTeamsQuery,
  useUpdateTeamMutation,
} from "../../../../Services/settingsAPIs/CommonAPI";
import {
  useGetAutoTicketNotificationQuery,
  useGetManualTicketNotificationQuery,
} from "../../../../Services/settingsAPIs/TicketSettingsAPI";
import { useGetAllWorkflowSelectedTeamIdQuery } from "../../../../Services/reports/tickets/ReportTickets";
import { v4 as uuidv4 } from "uuid"; // Add this import at the top
import ManualTicketRule from "./ManualTicketRule";

const Notifications = () => {
  const { data: teamsData } = useTeamsQuery({});
  const [theTeams, setTheTeams] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState<number>(0);
  const [optionsWorkflow, setOptionsWorkflow] = useState<any[]>([]);
  const [selectedWorkflow, setSelectedWorkflow] = useState<number>(0);
  const [selectedStatus, setSelectedStatus] = useState<any>([]);
  const [ticketNotificationsData, setTicketNotificationsData] = useState<any>({
    hasActiveAutoND: false,
    hasActiveManualND: false,
  });

  const [selectedTeamInfo, setSelectedTeamInfo] = useState();
  const [autoTicketGenEnabled, setAutoTicketGenEnabled] = useState(false);
  const [autoTicketNotificationEnabled, setAutoTicketNotificationEnabled] =
    useState(false);
  const [manualTicketNotificationEnabled, setManualTicketNotificationEnabled] =
    useState(false);

  const [triggerTeamMutation] = useTeamMutation();
  const [triggerUpdateTeamInfo] = useUpdateTeamMutation();
  const { data: workflowData } = useGetAllWorkflowSelectedTeamIdQuery(
    selectedTeam,
    {
      skip: !selectedTeam,
    }
  );
  // const {
  //   data: activeAutoTicketNotificationsData,
  //   isLoading: isLoadingActiveAutoTicketNotificationData,
  //   refetch: refetchATND,
  // } = useGetAutoTicketNotificationQuery(selectedTeam, {
  //   skip: !selectedTeam || !selectedWorkflow,
  // });
  // const {
  //   data: activeManualTicketNotificationsData,
  //   isLoading: isLoadingActiveManualTicketNotificationData,
  //   refetch: refetchMTND,
  // } = useGetManualTicketNotificationQuery(selectedTeam, {
  //   skip: !selectedTeam || !selectedWorkflow,
  // });

  const handleTeamDropdownChange = (event: any) => {
    setSelectedTeam(Number(event.target.value));
    setSelectedWorkflow(0);
  };
  const handleAutoTicketGenToggle = () => {
    setAutoTicketGenEnabled(!autoTicketGenEnabled);
    setSelectedTeamInfo((prev: any) => {
      return {
        ...prev,
        auto_ticket_generate_enabled: !prev.auto_ticket_generate_enabled,
      };
    });
  };
  const handleAutoTicketNotificationToggle = () => {
    setAutoTicketNotificationEnabled(!autoTicketNotificationEnabled);
    setSelectedTeamInfo((prev: any) => {
      return {
        ...prev,
        auto_ticket_notification_enabled:
          !prev.auto_ticket_notification_enabled,
      };
    });
  };
  const handleManualTicketNotificationToggle = () => {
    setManualTicketNotificationEnabled(!manualTicketNotificationEnabled);
    setSelectedTeamInfo((prev: any) => {
      return {
        ...prev,
        manual_ticket_notification_enabled:
          !prev.manual_ticket_notification_enabled,
      };
    });
  };
  const handleWorkflowDropdownChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setSelectedWorkflow(Number(e.target.value));
    const selectedWorkflowData = optionsWorkflow.find(
      (workflow) => workflow.value === Number(e.target.value)
    );
    // Add uuid to every status object
    const allStatusWithUuid = selectedWorkflowData?.allStatus?.map(
      (statusObj: any) => ({
        ...statusObj,
        uuid: uuidv4(),
      })
    );

    setSelectedStatus(allStatusWithUuid);
  };

  async function fetchTeamInfo() {
    triggerTeamMutation(selectedTeam)
      .then((res: any) => {
        res.data &&
          setAutoTicketGenEnabled(res.data.auto_ticket_generate_enabled);
        setAutoTicketNotificationEnabled(
          res.data.auto_ticket_notification_enabled
        );
        setManualTicketNotificationEnabled(
          res.data.manual_ticket_notification_enabled
        );
        setSelectedTeamInfo(res.data);
      })
      .catch((err: any) => console.log(err));
  }

  useEffect(() => {
    setTheTeams(teamsData);
  }, [teamsData]);
  useEffect(() => {
    selectedTeam && fetchTeamInfo();
  }, [selectedTeam]);
  useEffect(() => {
    selectedTeamInfo &&
      triggerUpdateTeamInfo({
        teamId: selectedTeam,
        body: selectedTeamInfo,
      });
  }, [selectedTeamInfo]);

  // useEffect(() => {
  //   setTicketNotificationsData((prevState: any) => {
  //     const newState = { ...prevState };

  //     if (
  //       !isLoadingActiveAutoTicketNotificationData &&
  //       activeAutoTicketNotificationsData?.length
  //     ) {
  //       newState.hasActiveAutoND = true;
  //       newState.auto = activeAutoTicketNotificationsData;
  //     }

  //     if (
  //       !isLoadingActiveManualTicketNotificationData &&
  //       activeManualTicketNotificationsData?.length
  //     ) {
  //       newState.hasActiveManualND = true;
  //       newState.manual = activeManualTicketNotificationsData;
  //     }

  //     return newState;
  //   });
  // }, [
  //   activeAutoTicketNotificationsData,
  //   activeManualTicketNotificationsData,
  //   isLoadingActiveAutoTicketNotificationData,
  //   isLoadingActiveManualTicketNotificationData,
  // ]);

  useEffect(() => {
    if (workflowData && workflowData?.results?.length > 0) {
      console.log(workflowData?.results, "workflowData");
      const transformedOptions = workflowData?.results?.map(
        (workflow: any) => ({
          label: workflow.name,
          value: workflow.id,
          allStatus: workflow?.all_statuses,
        })
      );
      setOptionsWorkflow(transformedOptions);
    } else {
      setOptionsWorkflow([]);
    }
  }, [workflowData]);

  console.log(ticketNotificationsData, "ticketNotificationsData");

  return (
    <div
      className="card-toolbar flex-row-fluid justify-content-end gap-5 p-5"
      style={{ marginLeft: "2%" }}
    >
      <div className="row align-items-center">
        <div className="col-md-2">
          <label>Select team</label>
          <select
            className="form-select select2-hidden-accessible"
            onChange={handleTeamDropdownChange}
            value={selectedTeam}
          >
            <option value={0}>Select team</option>
            {theTeams &&
              theTeams.map((team, index) => (
                <option key={index} value={team.id}>
                  {team.name}
                </option>
              ))}
          </select>
        </div>

        {selectedTeam !== 0 && (
          <>
            <div className="col-md-2">
              <label>Select workflow</label>
              <select
                className="form-select select2-hidden-accessible"
                onChange={handleWorkflowDropdownChange}
                value={selectedWorkflow}
              >
                <option value={0}>Select workflow</option>
                {optionsWorkflow &&
                  optionsWorkflow.map((workflow, index) => (
                    <option key={index} value={workflow.value}>
                      {workflow.label}
                    </option>
                  ))}
              </select>
            </div>
          </>
        )}
        {selectedTeam !== 0 && selectedWorkflow !== 0 && (
          <div className="col-md-8 d-flex align-items-center gap-5">
            <label className="me-3">Auto ticket generation</label>
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                disabled={!selectedTeam}
                checked={autoTicketGenEnabled}
                onChange={handleAutoTicketGenToggle}
              />
            </div>
            <label className="me-3">Auto ticket notification</label>
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                disabled={!selectedTeam}
                checked={autoTicketNotificationEnabled}
                onChange={handleAutoTicketNotificationToggle}
              />
            </div>
            <label className="me-3">Manual ticket notification</label>
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                disabled={!selectedTeam}
                checked={manualTicketNotificationEnabled}
                onChange={handleManualTicketNotificationToggle}
              />
            </div>
          </div>
        )}
      </div>
      <div style={{ maxHeight: "70vh", overflowY: "scroll", overflowX: "hidden" }}>
      {selectedTeam !== 0 &&
        autoTicketNotificationEnabled &&
        selectedWorkflow !== 0 && (
          <AutoTicketRules
            selectedTeam={selectedTeam}
            ticketNotificationsData={ticketNotificationsData}
            notificationType="auto_ticket"
            selectedStatus={selectedStatus}
            selectedWorkflow={selectedWorkflow}
          />
        )}
      {selectedTeam !== 0 &&
        manualTicketNotificationEnabled &&
        selectedWorkflow !== 0 && (
          <AutoTicketRules
            selectedTeam={selectedTeam}
            ticketNotificationsData={ticketNotificationsData}
            notificationType="manual_ticket"
            selectedStatus={selectedStatus}
            selectedWorkflow={selectedWorkflow}
          />
        )}
      </div>
    </div>
  );
};

export default Notifications;
